/** @jsx jsx */

import { Colors, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    border: 1px solid ${Colors.GrayWarm3};
    border-radius: 10px;
    height: 91px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  `,
};

const NoIssues = () => (
  <section css={Styles.root}>
    <Text type="Body1">No Open Bugs or Feature Requests</Text>
  </section>
);

export default NoIssues;
